export const CATEGORY_SPORT_PRODUCT = [
  {
    title: "ВСЁ",
    // type:'all',
  },
  {
    title: "🛼РОЛИКИ",
    type: "roller",
  },
  {
    title: "🛡️ЗАЩИТА",
    type: "protection",
  },
  {
    title: "⛑️ШЛЕМЫ",
    type: "helmet",
  },
  {
    title: "🎾ТЕННИС",
    type: "tennis",
  },
  {
    title: "🎾ПАДДЕЛ",
    type: "padel",
  },
  {
    title: "🏓ПИН-ПОНГ, МИНИ-ТЕННИС",
    type: "mini",
  },
  {
    title: "🏸БАДМИНТОН",
    type: "badminton",
  },
  {
    title: "⚾БЕЙСБОЛ",
    type: "baseball",
  },
  {
    title: "🥏ФРИЗБИ",
    type: "frisbee",
  },
  {
    title: "⚽МЯЧИ",
    type: "balls",
  },
  {
    title: "🌀НАСОСЫ",
    type: "pump",
  },
  {
    title: "💪ТРЕНАЖЕРНЫЙ ЗАЛ | ФИТНЕС",
    type: "fitness",
  },
  {
    title: "🥤ШЕЙКЕР",
    type: "shaker",
  },
  {
    title: "💪ЭСПАНДЕР",
    type: "extender",
  },

  {
    title: "🤸СКАКАЛКИ",
    type: "jumprope",
  },

  {
    title: "🧘‍♂️РЕЗИНКИ, ЖГУТЫ",
    type: "elasticbands",
  },
  {
    title: "🧘‍♂️КОВРИКИ ДЛЯ СПОРТА И ЙОГИ",
    type: "mats",
  },
  {
    title: "🔵МАССАЖНЫЙ МЯЧ | РОЛ | ОБРУЧ",
    type: "hoop",
  },
  {
    title: "🦵НАКОЛЕННИКИ, НАЛОКОТНИКИ",
    type: "kneePads",
  },
  // {
  //   title: "🏋️СПОРТИВНЫЕ ТОВАРЫ",
  //   type: "sportings",
  // },

  {
    title: "🌊ВОДНЫЙ СПОРТ",
    type: "watersport",
  },

  {
    title: "🏄SUP-ДОСКИ",
    type: "supboard",
  },
];
